export default {"src":"/_next/static/media/caller_icon.a2a000e6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};